import {useMemo} from 'react';
import type {DocumentReviewRoundResponse} from 'src/api/ProactApiClient';
import {useGetDocumentReviewRequestsQuery} from 'src/redux/queries/documentReview';
import {useDocumentReviewsFeature} from 'src/shared/hooks/useDocumentReviewsFeature';

/**
 * Fetches every review round for a document (all versions) and groups them
 * by `documentVersion`, for the Versions tab expandable row detail. Skipped
 * entirely when the DocumentReviews feature flag is off.
 */
export const useDocumentReviewRoundsByVersion = (documentId: number) => {
  const hasFeature = useDocumentReviewsFeature();

  const {data, isLoading} = useGetDocumentReviewRequestsQuery(
    {documentId},
    {skip: !hasFeature || !documentId}
  );

  const roundsByVersion = useMemo(() => {
    const map = new Map<number, DocumentReviewRoundResponse[]>();
    (data ?? []).forEach(round => {
      const existing = map.get(round.documentVersion) ?? [];
      existing.push(round);
      map.set(round.documentVersion, existing);
    });
    return map;
  }, [data]);

  return {hasFeature, isLoading, roundsByVersion};
};
